import { useLayoutEffect, useEffect } from 'react';

// 確保不會在 SSR 出現警告
export const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect;
